export enum RacingSport {
  HORSE_RACING = 7,
  GREYHOUND_RACING = 4339,
}

export enum VirtualSport {
  HorsesFlat = 0,
  HorsesJumps = 100,
  HorsesSprint = 10,
}

export const ExchangeSide = {
  BACK: "BACK",
  LAY: "LAY",
} as const;
export type ExchangeSide = (typeof ExchangeSide)[keyof typeof ExchangeSide];

export const ExchangeMarketStatus = {
  Open: "OPEN",
  Closed: "CLOSED",
  Suspended: "SUSPENDED",
} as const;
export type ExchangeMarketStatus = (typeof ExchangeMarketStatus)[keyof typeof ExchangeMarketStatus];

export const BetslipType = {
  SPORTSBOOK: "SPORTSBOOK",
  OBB: "OBB",
} as const;
export type BetslipType = (typeof BetslipType)[keyof typeof BetslipType];

export const EventType = {
  FOOTBALL: 1,
  LOTTERIES: 29125756,
  HORSE_RACING: 7,
} as const;
export type EventType = (typeof EventType)[keyof typeof EventType];
